import styled from 'styled-components'

export const ExportContainer = styled.div`
    background: transparent;
`
